import { useEffect } from 'react';
import { ModalBodyVariant } from "./ModalBodyVariant";
import { useModalLayout } from "./ModalLayoutContext";
export var ModalBody = _ref => {
  var {
    children,
    variant = ModalBodyVariant.Default
  } = _ref;
  var {
    setLayout
  } = useModalLayout();
  useEffect(() => {
    setLayout({
      body: children,
      bodyVariant: variant
    });
    return () => setLayout({
      body: null,
      bodyVariant: ModalBodyVariant.Default
    });
  }, [children, setLayout]);
  return null;
};